import classNames from 'classnames'
import PaperCard from 'components/report/PaperCard'
import styles from './styles/Result.css'

const Result = ({
  refNumber, resultRef, className, result, textMatch, textMatches, showAbstract = false, card = true, showClassification = true,
  showLinks = true, showMenu = true, showClickToCopy = true, truncateSnippets = false
}) => (
  <div ref={resultRef} className={classNames(className, styles.result)}>
    <PaperCard
      refNumber={refNumber}
      paper={result}
      tally={result?.tally}
      citations={result?.citations}
      showAbstract={showAbstract}
      showClassification={showClassification}
      card={card}
      linkTarget
      textMatch={textMatch}
      textMatches={textMatches}
      showLinks={showLinks}
      showMenu={showMenu}
      showClickToCopy={showClickToCopy}
      truncateSnippets={truncateSnippets}
    />
  </div>
)

export default Result
